import React, { useState } from 'react'
import styled from 'styled-components'
import { Product, ProductVariantOption } from '../stores/ProductModel'
import { priceFormatter } from '@/lib/utils'
import { getPriceOptionsFromProduct } from './GetPriceOptionsFromProduct'
import themeGet from '@styled-system/theme-get'
import { SmallTypeSelect } from './SmallTypeSelect'
import { PLAN_TEACHING } from '@/lib/utils/renderType'

export interface ProductDynamicPriceProps {
	product: Product
	onPriceChange: (product: Product, variant: ProductVariantOption) => void
	useNewPlan: boolean
	useParsingBadge: boolean
}

export const ProductDynamicPrice: React.FC<ProductDynamicPriceProps> = ({
	product,
	onPriceChange,
	useNewPlan,
	useParsingBadge,
}) => {
	const sourceType = product?.source_type

	// const resultPriceStr = useNewPlan ? 'view' : sourceType === 'handout' ? 'lite' : 'basic'
	const resultPriceStr = useNewPlan ? PLAN_TEACHING : sourceType === 'handout' ? 'lite' : 'basic'

	const resultPrice = product.product_variants.filter(
		(item) => item.options.license_plan === resultPriceStr,
	)[0]

	const [selectedPrice, setSelectedPrice] = useState<number>(resultPrice?.price || 0)
	const onPriceUpdateHandle = (value) => {
		const variant = product.product_variants?.find((variant) => variant.options.value === value)

		const nextPrice = variant?.price || 0
		setSelectedPrice(nextPrice)
		onPriceChange(product, variant)
	}
	const priceOptions = getPriceOptionsFromProduct(product)

	return (
		<ProductDynamicPriceWrapper>
			{/*{useParsingBadge && (*/}
			{/*	<Image*/}
			{/*		src={'/static/assets/label-edit.svg'}*/}
			{/*		alt={'parsing badge'}*/}
			{/*		width={75}*/}
			{/*		height={20}*/}
			{/*		className={'badge-img'}*/}
			{/*		style={{ marginLeft: '16px' }}*/}
			{/*	/>*/}
			{/*)}*/}

			{!useNewPlan && (
				<SmallTypeSelect
					onChange={onPriceUpdateHandle}
					defaultValue={
						sourceType === 'handout' ? priceOptions[0]?.value : priceOptions[1]?.value
					}
					popupClassName={'price-type-select'}
					style={{ width: 84 }}
					options={priceOptions}
				/>
			)}
			<div className="price">{priceFormatter(selectedPrice)}원</div>
			{/*{useNewPlan && <span className={'price-desc'}> 부터</span>}*/}
		</ProductDynamicPriceWrapper>
	)
}

const ProductDynamicPriceWrapper = styled.div`
	margin-right: 24px;
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	body:has(&) .price-type-select {
		text-align: center;
	}

	.ant-select {
		.ant-select-selector {
			text-align: right;
			padding-right: 12px;
			border: 0;
			border-radius: 0;
		}
		.ant-select-arrow {
		}

		@media (max-width: 768px) {
			display: none;
		}
	}

	.price {
		width: auto;
		max-width: 102px;
		font-size: 14px;
		font-weight: bold;
		text-align: right;
		word-break: break-word;
		padding-left: 16px;

		@media (max-width: 768px) {
			width: 84px;
		}
	}

	@media (max-width: 1200px) {
		margin-right: 0;
	}
	@media (max-width: 768px) {
		margin-right: 0;
	}
	.price-desc {
		margin-left: 4px;
		font-size: 14px;
		color: ${themeGet('text.2', '#BBBBBF')};
	}
`
